import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";
import BookingTable from './BookingTable';
import LoginPage from './LoginPage';
import Impressum from './Impressum';
import NewBooking from './NewBooking';

const root = document.getElementById("root");
ReactDOM.createRoot(root).render(
  <BrowserRouter>
    <Routes>
      <Route>
        <Route index element={<App />} />
        <Route path='login' element={<LoginPage/>}/>
        <Route path="plan" element={<BookingTable/>}/>
        <Route path='new-booking' element={<NewBooking/>}/>
        <Route path="impressum" element={<Impressum/>}/>
      </Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
